<template>
  <div class="admin" v-if="admin">
    <breadcrumbs :items="breadcrumbs">
      
      <div class="activation">
        <div class="admin-action">
          <rp-status :statusInfo="admin.activated_at" />
        </div>

        <div class="admin-action">
          <rp-button
            border-radius
            button-type="normal"
            @click="activateAdmin">
            {{adminActive === 'Active' ? 'deactivate' : 'activate'}}
          </rp-button>
        </div>

        <div class="admin-action">
          <router-link :to="{ name: 'edit-admin', params: { id: this.$route.params.id}}">
            <rp-sprite class="create-icon" name="create" />
          </router-link>
          <rp-sprite @click.native="activeConfirm = !activeConfirm" class="create-icon" name="delete_outline" />
        </div>
      </div>
    
    </breadcrumbs>

    <div class="content">
      <div class="admin-info">
        <div class="info-group">
          <h3>First Name</h3>
          <p>{{admin.profile.first_name ? admin.profile.first_name : 'NOT PROVIDED'}}</p>
        </div>
        <div class="info-group">
          <h3>Last Name</h3>
          <p>{{admin.profile.last_name ? admin.profile.last_name : 'NOT PROVIDED'}}</p>
        </div>
        <div class="info-group">
          <h3>Email Address</h3>
          <p>{{admin.email ? admin.email : 'NOT PROVIDED'}}</p>
        </div>
        <div class="info-group">
          <h3>Gender</h3>
          <p>{{admin.profile.gender | genderFilter}}</p>
        </div>
      </div>

      <rp-overlay :active="activeOverlay">
        <rp-alert
          icon="done"
          :message="successMessage"
          :onClick="successFunction" />
      </rp-overlay>

      <rp-overlay :active="activeConfirm">
        <rp-delete-confirm
          icon="warning"
          userType="Raypro_admin"
          messageType='Delete '
          :userName="userName"
          :cancel="cancelDeletion"
          :confirm="confirmDeletion" />
      </rp-overlay>

      <rp-overlay :active="activeDelete">
        <rp-alert
          icon="done"
          :message="alertMessage"
          :onClick="alertFunction" />
      </rp-overlay>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs'
import Status from 'raypro_ui/src/components/ui/Status'
import Button from 'raypro_ui/src/components/ui/inputs/Button'
import Sprite from 'raypro_ui/src/components/ui/Sprite'
import Overlay from 'raypro_ui/src/components/ui/Overlay'
import DeleteConfirm from 'raypro_ui/src/components/ui/DeleteConfirm'
import Alert from 'raypro_ui/src/components/ui/Alert'
import Table from 'raypro_ui/src/components/ui/Table'
import page from '@/mixins/page'

// API
import {getUser, activateUser, deactivateUser, deleteUser} from 'raypro_ui/src/api/users'

export default {
  components: {
    Breadcrumbs,
    'rp-status': Status,
    'rp-button': Button,
    'rp-sprite': Sprite,
    'rp-table': Table,
    'rp-overlay': Overlay,
    'rp-alert': Alert,
    'rp-delete-confirm': DeleteConfirm
  },

  data() {
    return {
      admin: null,
      activeOverlay: false,
      activeConfirm: false,
      activeDelete: false,
      title: 'Admin',
      page: {
        totalPages: 1,
        totalentries: 0,
        pageSize: 10,
        pageNumber: 1
      },
    }
  },

  props: {id: String},

  mixins: [page],

  mounted() {
    this.getUser()
  },

  filters: {
    genderFilter(gender) {
      if(gender === 'PATIENT DELETED') {
        return gender
      }
      if(gender === 'M') {
        return 'Male'
      }
      if(gender === 'F') {
        return 'Female'
      }
      if(gender === 'O') {
        return 'Prefer not to say'
      }

      return 'NOT PROVIDED'
    }
  },

  computed: {
    userName() {
      return `${this.admin.profile.first_name} ${this.admin.profile.last_name}`
    },

    alertMessage() {
      return `${this.admin.profile.first_name} ${this.admin.profile.last_name} deleted successfully!`
    },

    currentBreadcrumb() {
      return `${this.userName}`
    },

    breadcrumbs() {
      return [
        {
          label: 'Admins',
          link: 'all-users',
          params: {role: 'raypro_admin'}
        },
        {label: this.currentBreadcrumb}
      ]
    },

    adminActive() {
      return this.admin.activated_at ? 'Active' : 'Inactive'
    },

    successMessage() {
      return `Admin ${this.adminActive === 'Active' ? 'deactivated' : 'activated'} successfully!`
    }
  },

  methods: {
    getUser() {
      getUser(this.id).then(({data}) => {
        this.admin = data
      })
    },

    successFunction() {
      this.activeOverlay = false
      this.getUser()
    },

    activateAdmin() {
      if(this.adminActive === 'Active') {
        deactivateUser({id: this.id})
          .then(() => {
            this.activeOverlay = true
          })
          .catch(({response}) => {
            this.errors = response.errors
          })
      } else {
        activateUser({id: this.id})
          .then(() => {
            this.activeOverlay = true
          })
          .catch(({response}) => {
            this.errors = response.errors
          })
      }
    },

    alertFunction() {
      this.$router.push({name: 'all-users'})
    },

    cancelDeletion() {
      this.activeConfirm = !this.activeConfirm
    },

    confirmDeletion() {
      deleteUser({id: this.id})
        .then(() => {
          this.activeConfirm = !this.activeConfirm
          this.activeDelete = !this.activeDelete
        })
    }
  }
}
</script>

<style lang="sass">
@import 'raypro_ui/src/styles/base/_variables.sass'
@import 'raypro_ui/src/styles/helpers/_mixins.sass'

.activation
  display: flex
  align-items: center
  justify-content: flex-end
  .admin-action
    margin-left: 15px
    .btn
      margin-top: 0px
      color: $color-text-invert
      border-color: $color-grey


.admin
  .content
    display: flex
    flex-direction: column
    @include media($media-medium)
      padding: 0 40px
      flex-direction: row
      justify-content: space-between
    .admin-info
      @include media($media-medium)
        width: 40%
      .info-group
        display: flex
        flex-direction: column
        @include media($media-medium)
          flex-direction: row
          align-items: center
        h3
          display: inline-flex
          width: 150px
          min-width: 150px
          margin: 0
          text-transform: initial
          font-weight: lighter
        p
          display: inline-flex
          line-height: 1
          font-weight: bold
          word-break: break-word
      hr
        margin: 20px 0 36px
        border-top: 1px solid $color-grey-dark
    .modal-header
      padding: 20px
      font-size: 20px
      border-bottom: 2px solid #e2e4e4

    .modal-body
      min-height: 500px

</style>



// WEBPACK FOOTER //
// src/components/pages/RayproAdmin/RayproAdmin.vue